var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentSubproject.name)?_c('v-chip',{staticClass:"ml-2",attrs:{"color":"primary","outlined":"","close":""},on:{"click:close":_vm.closeSubproject}},[_vm._v(" "+_vm._s(_vm.currentSubproject.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }